<template>
  <l-layout :layout="['xs12']">
    <l-data-table
    :get-data-func="getPackageList"
    :headers="header"
    ref="packageList"
    @click:row="getDetails($event.item)"
    clickable
    title-text="硬件程序包列表">
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-tooltip left>
            <v-btn @click="deletePackageConfirm(item)" slot="activator" icon>
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      @click="addPackage"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
    import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
    export default {
        name: "packageList",
      components: {LDataTable},
      data(){
          return {
            header:[
              {text:'程序包名',value:'name',sortable:false,align:'left'},
              {text:'上传时间',value:'creationTime',sortable:true,align:'left'},
              {text:'',value:'',sortable:false,align:'left'}
            ]
          }
      },
      methods:{
        async getPackageList({pagination,filter,search}){
         let {items,amount} = await this.$store.dispatch('iot/getPackageList',{pagination})
          console.log(items)
          return {items:items,amount:amount}
        },
        addPackage(){
            this.$router.push({
              name:'newIotPackage'
            })
        },
        async deletePackageConfirm (item) {
          let {res, close} = await this.$L.confirm({
            title: '确认删除该程序包？',
            text: '程序包名称:' + item.name
          })
          if (res) {
            try {
              await this.deletePackage(item)
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
        async deletePackage (item) {
          let ids = []
          ids.push(item.id)
          let params = {
            "ids":ids
          }
          let res = await this.$store.dispatch('iot/deletePackage', params)
          if (res.data.status + '' === '200') {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.packageList.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        },
        getDetails(item){
          let selectionString = document.getSelection().toString()
          if (!selectionString) {
            this.$router.push({name:'packageDetailBox',query:{id:item.id}})
          }
        }
      }
    }
</script>

<style scoped>

</style>
